import { render, staticRenderFns } from "./OrdersBooker.vue?vue&type=template&id=4bae6938&scoped=true"
import script from "./OrdersBooker.vue?vue&type=script&lang=js"
export * from "./OrdersBooker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae6938",
  null
  
)

export default component.exports